import(/* webpackMode: "eager" */ "/vercel/path0/app/bourse/page.tsx");
